import { useState, useEffect } from 'react'

import profile from 'scripts/components/user/profile'

const ASSISTED_SALE_CONTEXT = 'assisted-sale'
const APP_CONTEXT = 'app'

export const useProfile = () => {
  const [data, setData] = useState({})
  const [isLoadingProfile, setIsLoadingProfile] = useState(true)
  const [isOnMobileApp, setIsOnMobileApp] = useState(false)
  const [isAssistedSale, setIsAssistedSale] = useState(false)

  const setContext = context => {
    setIsAssistedSale(context === ASSISTED_SALE_CONTEXT)
    setIsOnMobileApp(context === APP_CONTEXT)
  }

  useEffect(() => {
    profile.get()
      .then(response => {
        setData(response)
        setContext(response.context)
      })
      .catch(() => setData({}))
      .finally(() => setIsLoadingProfile(false))
  }, [])

  return {
    profile: data,
    isLoadingProfile,
    isOnMobileApp,
    isAssistedSale
  }
}
